import { BrutalistBadge, SolidBlock } from "@/app/components/brand-scaffold";
import { statusQuoCards } from "@/design-system/registry/homepage";

export function HomepageRealStatus() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20 bg-black/[0.04]">
      <div className="mx-auto max-w-5xl">
        <div className="mb-8">
          <BrutalistBadge bgClass="bg-white" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white">
            REAL STATUS
          </BrutalistBadge>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-black mb-4">
          当前真实状态
        </h2>
        <p className="text-lg font-bold text-zinc-600 mb-10">
          我们不会把远期规划写成已有功能。
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {statusQuoCards.map((card) => (
            <SolidBlock
              key={card.num}
              bgClass={`${card.bg} ${card.text}`}
              hoverClass={card.hoverBg}
              className="!p-5 transition-all"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="font-black text-xs opacity-60">{card.num}</span>
                <StatusBadge status={card.status} />
              </div>
              <h3 className="font-black text-lg mb-1">{card.title}</h3>
              <p className="text-sm opacity-90">{card.body}</p>
            </SolidBlock>
          ))}
        </div>
        <p className="mt-8 text-base font-bold text-zinc-800">
          现在最推荐的第一步：本地跑通一次 Hotline call。
        </p>
      </div>
    </section>
  );
}

function StatusBadge({ status }: { status: "available" | "preview" | "planned" }) {
  const styles = {
    available: "bg-black text-white",
    preview: "bg-white text-black border border-black",
    planned: "bg-white/80 text-black border border-black/30",
  };
  const labels = { available: "可用", preview: "预览", planned: "规划中" };
  return (
    <span className={`px-2 py-0.5 text-[10px] font-black uppercase ${styles[status]}`}>
      {labels[status]}
    </span>
  );
}
